import { useRequest } from "../../../hooks/useRequest";
import { useEffect } from "react";
import { ClientApiResponse } from "../types";
import { AxiosResponse } from "axios";
import { countryFormatter } from "../../../shared/utils";
import routes from "../../../routes";

const publicStatusFormatter = (url: string) => ({
  url,
});

function useClientList() {
  const { loading, fetch, response, error } = useRequest();

  useEffect(() => {
    fetch("GET", routes.api.clients.base({}));
  }, [fetch]);

  const generateDataGridFormat = (
    clients: AxiosResponse<Array<ClientApiResponse>> | undefined,
  ) => {
    if (clients) {
      return clients.data.map((client: ClientApiResponse) => ({
        id: client.id,
        displayName: client.name,
        ownerEmail: client.mainUser.email,
        createdAt: client.dateCreated,
        lastUpdated: client.lastUpdated,
        public: publicStatusFormatter(client.teamsProfileUrl),
        street: client.address.street,
        city: client.address.city,
        zipCode: client.address.zipCode,
        country: countryFormatter(client.address.country),
        products: client.products,
        paymentPlan: client.pricingPlan?.level,
      }));
    }
    return [];
  };

  return {
    loading,
    clientList: generateDataGridFormat(response),
    error,
  };
}

export default useClientList;
